import React from 'react';
import styled from 'styled-components';

import { Button, TextField, Paper } from 'components'
import { FaArrowRight } from 'react-icons/fa'

const Wrapper = styled.div`
    transform: ${props => props.offsetY && `translateY(${props.offsetY})`};
`

const Content = styled.div`
    background-color: var(--primary-color);
    border: 1px solid var(--primary-accent-color);
    box-shadow: var(--box-shadow);
    border-radius: 5px;
    padding: 0.2rem 0.5rem;
    width: 15rem;
    display: flex;
    flex-direction: column;
`

const Container = styled.div`
    display: grid;
    grid-template-columns: auto 2rem;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
    /* margin-top: 0.2rem; */
    :before {
        content: '*'
    }
`

const LinkInput = props => {
    const {
        onSubmit,
        onClose,
        offsetY
    } = props;
    const [link, setLink] = React.useState('')
    const [error, setError] = React.useState(false)

    const validURL = (str) => {
        const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        
        return !!pattern.test(str) & str.length > 0;
    }

    const onSubmitHandler = () => {
        const check = validURL(link)
        if(check){
            onSubmit(link)
            props.closeHandler && props.closeHandler()
        } else {
            setError(true)
        }
    }

    const keyHandler = (event) => {
        // Enter
        if (event.charCode === 13) {
            onSubmitHandler(link)
            
        } 
        else if (event.keyCode === 27 ) {
            setLink(null)
            setError(false)
            onClose && onClose()
            props.closeHandler && props.closeHandler()
        } 
    }

    const buttonStyle = {
        backgroundColor: 'transparent',
        boxShadowColor: 'transparent',
        margin: 0,
        padding: '0.5rem 0'
    }

    return (
        <Wrapper offsetY={offsetY}>
            <Content>
                <Container>
                    <TextField type='single' onChange={(event) => setLink(event.target.value)} value={link} placeholder='Paste link' focus={true}
                            onKeyPress={keyHandler} onKeyDown={keyHandler}/>
                    <Button icon={<FaArrowRight/>} onSelect={onSubmitHandler} styles={buttonStyle} />
                </Container>

                {error && <Error>Invalid URL</Error>}
            </Content>
        </Wrapper>
    )
}

export default LinkInput;